import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { hmrBootstrap } from './hmr';
import initSentry from './sentry';

// Sentry
initSentry()

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

if (environment.PROD) {
  enableProdMode();
}

if (environment.HMR) {
  if (module['hot']) {
    hmrBootstrap(module, bootstrap);
  } else {
    console.error('HMR is not enabled for webpack-dev-server!');
    console.log('Are you using the --hmr flag for ng serve?');
  }
} else {
  bootstrap();
}

(function (global) {
  const console_log = global.console.log;
  global.console.log = function () {
    if (!(
      arguments.length === 1 &&
      typeof arguments[0] === 'string' &&
      arguments[0].match(/^\[(HMR|WDS)\]/)
    )) {
      console_log.apply(global.console, arguments);
    }
  };
})(window);
